import { Box, styled } from '@ltvco/refresh-lib/theme';
import { useLocation } from 'react-router-dom';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { useBannerLogic } from '@ltvco/refresh-lib/v2';

const AppWrapper = styled('div')(({ theme }) => ({
  margin: '20px 16px 20px 16px',
  backgroundColor: theme.palette.background.default,
  paddingBottom: theme.spacing(0.25),
  [theme.breakpoints.up('md')]: {
    margin: 0,
  },
}));

export function AppContainer({
  children,
}: {
  children: React.ReactNode | React.ReactNode[];
}) {
  const location = useLocation();
  const { isDesktop } = useScreenSize();
  const { isUserInTest } = useBannerLogic();
  const isOnReportView = location.pathname.includes('/report/');

  return (
    <AppWrapper
      id={isUserInTest && isDesktop ? 'app-container' : ''}
      sx={{
        marginX: isOnReportView ? 0 : null,
      }}
    >
      <Box>{children}</Box>
    </AppWrapper>
  );
}
